import { Box, styled } from '@mui/material';

export const Content = styled(Box)(({ theme }) => ({
  border          : `1px solid ${theme.palette.primary.gray3}`,
  borderRadius    : '10px',
  boxSizing       : 'border-box',
  backgroundColor : theme.palette.primary.white,
  flex            : 1,
  display         : 'flex',
  flexDirection   : 'column',
  alignItems      : 'center',
  justifyContent  : 'center',
  gap             : '8.5px',
  height          : '320px',
}));
